import { defaultBundleColorLabel } from "./defaultBundleColorLabel";

export default function unifyGroupVariants(product, includeHidden) {
  if (!product) {
    return [];
  }

  const variantSources = [product];

  if (product.group?.products) {
    variantSources.push(...product.group.products);
  }

  const variants = {};

  variantSources.forEach((variantSource) => {
    let bundleColorOption = null;

    if (variantSource.bundleColor) {
      bundleColorOption = {
        name: product.bundleColorLabel || defaultBundleColorLabel,
        value: variantSource.bundleColor.label,
      };
    }

    variantSource.variants.forEach((variant) => {
      if (includeHidden !== true && JSON.parse(variant.hideOnPdp)) return;

      if (bundleColorOption) {
        const selectedBundleColorOption = variant.selectedOptions.find(
          ({ name }) => name === bundleColorOption.name,
        );

        if (!selectedBundleColorOption) {
          variant.selectedOptions = [
            bundleColorOption,
            ...variant.selectedOptions,
          ];
        }
      }
      variants[variant.id] = variant;
    });
  });

  return Object.values(variants);
}
